<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title"><a id="pro"></a>PROLOGUE</p>
<p class="normal">The blast took her face off. Two seconds of pressure on the trigger and a full shotgun load went roaring out.</p>
<p class="indent">We’d been doing good. In with a maximum of ferocity. Get ’em terrorised, shouting ‘Get the fuck down – <span class="smallcaps">NOW</span>.’</p>
<p class="indent">Push push push.</p>
<p class="indent">Let ’em see the guns, hear the manic screaming of very dangerous men.</p>
<p class="indent">Doc had planted devices at the</p>
<p class="indent1">cop shop</p>
<p class="indent">Tesco</p>
<p class="indent">The Masonic Lodge</p>
<p class="normal">They’d gone off like lubrication. You had the noise, smoke, confusion and then we’re in – ‘MENACE’ writ brutal large.</p>
<p class="indent">Oh yeah, fuckin’ A.</p>
<p class="indent">Bingo, the motherload. More cash than Camelot, two bin-liners overflowing with readies.</p>
<p class="indent">Everything hunky-dory…. and then …</p>
<p class="indent">Then I shot the cashier in the face.</p>
<p class="indent">I guess it began with Cassie.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?5cf42025